var $1aa678c2c836a268$exports = {};
$1aa678c2c836a268$exports = {
    "replaceMessage": `P\u{159}et\xe1hn\u{11B}te soubor k nahrazen\xed`
};


export {$1aa678c2c836a268$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
